import { grafanaLogout } from "./grafanaLogout";
import userManager from "../auth/userManager";

// Ends the session via the OIDC library's RP-Initiated end-session flow
// (see docs/specs/0001-oidc-migration.md, ticket 06). Grafana logout is a
// best-effort side effect (grafanaLogout() swallows its own errors) -
// awaited here, before signoutRedirect() navigates the browser away, so
// it isn't cut off mid-flight.
export async function performLogout() {
  await grafanaLogout();
  return userManager.signoutRedirect();
}

